import React from 'react';
import { graphql } from 'gatsby';
import Page from '../components/Page';
import Hero from '../components/Hero';
import PageMeta from '../components/PageMeta';
import DownloadSection from '../components/DownloadSection';
import ProductCardsSection from '../components/ProductCardsSection';

const ProductLandingPage = ({ data }) => {
  const { pageMeta, pageHero, productCardsSection, downloadSection } =
    data.contentfulProductLandingPage;
  return (
    <Page>
      <PageMeta {...pageMeta} />
      <Hero {...pageHero} />
      <ProductCardsSection {...productCardsSection} />
      <DownloadSection {...downloadSection} />
    </Page>
  );
};

export const query = graphql`
  query {
    contentfulProductLandingPage (slug: {eq: "product-overview"}) {
      pageMeta {
        ...PageMeta
      }
      pageHero {
        ...Hero
      }
      productCardsSection {
        ...ProductCardsSection
      }
      downloadSection {
        ...DownloadSection
      }
    }
  }
`;

export default ProductLandingPage;
